
import { RouteObject } from "react-router-dom";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

// Lender Pages
import LenderDashboard from "@/pages/lender/Dashboard";
import ActiveLoans from "@/pages/lender/loans/ActiveLoans";
import LoanDetails from "@/pages/lender/loans/LoanDetails";
import Applications from "@/pages/lender/loans/Applications";
import ApplicationDetails from "@/pages/lender/loans/ApplicationDetails";
import ApplicationReview from "@/pages/lender/loans/ApplicationReview";
import RiskAssessment from "@/pages/lender/loans/RiskAssessment";
import Performance from "@/pages/lender/analytics/Performance";
import Portfolio from "@/pages/lender/analytics/Portfolio";
import RiskAnalysis from "@/pages/lender/ai/RiskAnalysis";
import Trends from "@/pages/lender/ai/Trends";
import Borrowers from "@/pages/lender/Borrowers";
import BorrowerDetails from "@/pages/lender/borrowers/BorrowerDetails";
import Settings from "@/pages/lender/Settings";

const lenderRoutes: RouteObject[] = [
  {
    path: "/lender/dashboard",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><LenderDashboard /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><LenderDashboard /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/active",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><ActiveLoans /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/details/:id",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><LoanDetails /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/applications",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Applications /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/applications/:id",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><ApplicationDetails /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/applications/:id/review",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><ApplicationReview /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/loans/risk",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><RiskAssessment /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/analytics/performance",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Performance /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/analytics/portfolio",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Portfolio /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/ai/risk",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><RiskAnalysis /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/ai/trends",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Trends /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/borrowers",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Borrowers /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/borrowers/:id",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><BorrowerDetails /></Layout>
      </ProtectedRoute>
    ),
  },
  {
    path: "/lender/settings",
    element: (
      <ProtectedRoute allowedRoles={['lender']}>
        <Layout><Settings /></Layout>
      </ProtectedRoute>
    ),
  },
];

export default lenderRoutes;
